import * as tslib_1 from "tslib";
import { AfterViewInit, OnDestroy, OnInit, SecurityContext } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxMasonryComponent } from 'ngx-masonry';
import { AppComponent } from '../app.component';
import { UrlService } from '../model/url.service';
import { GlobalService } from '../model/global.service';
import { ComponentsService } from '../model/components.service';
import { SugarService } from '../model/sugar.service';
import { MetaData } from '../shared/metadata/metadata.service';
import { ImagesPresentationModule } from '../images-presentation/images-presentation.module';
import { ModalFormComponent } from '../modal-form/modal-form.component';
import { SocialShareComponent } from '../social-share/social-share.component';
import { UniversalPlatformService } from '../shared/platform/universal-platform.service';
import { ExhibitionSingleItemSetter } from '../shared/collections/api-collection-setters';
import * as imagesLoaded from 'imagesloaded';
import { AutoUnsubscribe } from '../decorators/autounsubscribe.decorator';
import { getIndicesOf } from '../helpers/string-helpers';
import { getExpandText } from '../helpers/helpers';
var ExhibitionItemComponent = /** @class */ (function () {
    function ExhibitionItemComponent(domSanitizer, globalService, urlService, sanitizer, route, componentsService, platformService, sugarService, rootComp, metadata) {
        var _this = this;
        this.domSanitizer = domSanitizer;
        this.globalService = globalService;
        this.urlService = urlService;
        this.sanitizer = sanitizer;
        this.route = route;
        this.componentsService = componentsService;
        this.platformService = platformService;
        this.sugarService = sugarService;
        this.rootComp = rootComp;
        this.metadata = metadata;
        this.archiveExhibition = {
            pl: 'Wystawa archiwalna',
            en: 'Past exhibition',
        };
        this.activeTextElementsOnHoverEnabled = false;
        this.isDescriptionExpanded = false;
        this.activeTextElementsOnHoverEnabled = this.globalService.settings.global.activeTextElementsOnHoverEnabled === 'true';
        this.cutDescription = this.globalService.settings.global.cutDescriptions === 'true';
        this.cutDescriptionMaxLength = Number(this.globalService.settings.global.cutDescriptionMaxLength);
        if (isNaN(this.cutDescriptionMaxLength)) {
            this.cutDescriptionMaxLength = 400;
        }
        this.zoomImages = this.globalService.settings.global.sliderRotation === 'true';
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.id = parseInt(params['id'], 10);
        });
        this.rootSub = this.componentsService.getRootComponents().subscribe(function (apiData) {
            var data = apiData ? apiData : null;
            if (data && data.main_contents && data.main_contents.title) {
                _this.breadcrumbRootsTitle = data.main_contents.title;
            }
        });
        this.globalService.loadGlobalSettings().subscribe(function (settings) {
            if (settings.__loaded) {
                _this.isMasonry = settings.global.isMasonry;
                _this.isFourColumns = settings.global.isFourColumns;
            }
        });
        this._preloadingImages = false;
    }
    Object.defineProperty(ExhibitionItemComponent.prototype, "getExpandText", {
        get: function () {
            return getExpandText(this.isDescriptionExpanded);
        },
        enumerable: true,
        configurable: true
    });
    ExhibitionItemComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.rootComp.fbService.updateCommonOg();
        this.sugarService.setCollection('exhibition', {
            sugarNode: 'exhibitions/' + this.id,
            parameters: {
                expand: 'images,artists,attachments',
            },
        });
        this.sugarService.setCollection('exhibition-catalogue', {
            sugarNode: 'exhibitions/' + this.id + '/products',
            parameters: {
                expand: 'images,artists,exhibition_item',
            },
        });
        this.sugarService.setCollection('exhibition-events', {
            sugarNode: 'exhibitions/' + this.id + '/events',
            parameters: {
                expand: 'images',
            },
        });
        var itemSetter = new ExhibitionSingleItemSetter(this.urlService, this.platformService, this.sanitizer, this.sugarService);
        this.dataSub = this.sugarService.getData().subscribe(function (data) {
            if (data.collectionId === 'exhibition') {
                var exhibition = itemSetter.setup(data.data);
                _this.metadata.setItemPageMetaFromProperties(exhibition, 'banner');
                _this._exhibition = exhibition;
                _this._exhibition.url = _this.urlService.fullLink('exhibitions') + '/' + _this._exhibition.id;
            }
            if (data.collectionId === 'exhibition-catalogue') {
                var images = [];
                var image = void 0;
                var work = void 0;
                _this._preloadingImages = true;
                _this._works = itemSetter.setupWorks(data.data);
                for (var w = 0; w < (_this._works || []).length; ++w) {
                    work = _this._works[w];
                    if (work.images && (work.images || []).length) {
                        image = new Image();
                        image.src = work.images[0] ? work.images[0].thumbnails.slideshow.url : 'assets/images/placeholder-450x340.jpg';
                        images.push(image);
                    }
                }
                var imgLoaded = imagesLoaded(images);
                // wszystkie załadowane
                imgLoaded.on('done', function () {
                    _this._afterPreload();
                });
                // przynajmniej jeden zwrócił błąd
                imgLoaded.on('fail', function () {
                    _this._afterPreload();
                });
                _this._worksPagination = data.pagination;
            }
            if (data.collectionId === 'exhibition-events') {
                _this._events = itemSetter.setupEvents(data.data);
            }
        });
        this.sugarService.refreshData('exhibition');
        this.sugarService.refreshData('exhibition-catalogue');
        this.sugarService.refreshData('exhibition-events');
    };
    ExhibitionItemComponent.prototype.description = function () {
        var _this = this;
        var plain = (this.domSanitizer.sanitize(SecurityContext.HTML, this._exhibition.description[this.urlService.langCode]) || '').trim();
        var spacesPositions = getIndicesOf(plain, ' ');
        this.cutDescriptionMaxLength = spacesPositions.filter(function (pos) { return pos >= _this.cutDescriptionMaxLength; })[0];
        this.cutDescription = this.cutDescription && (plain || []).length > this.cutDescriptionMaxLength;
        return this.cutDescription && !this.isDescriptionExpanded
            ? (plain.slice(0, this.cutDescriptionMaxLength)) + '...'
            : this._exhibition.description[this.urlService.langCode];
    };
    ExhibitionItemComponent.prototype.toggleDescription = function () {
        this.isDescriptionExpanded = !this.isDescriptionExpanded;
    };
    ExhibitionItemComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.rootComp.bodyClass = 'single-exhibition';
        });
    };
    ExhibitionItemComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
        if (this.rootSub) {
            this.rootSub.unsubscribe();
        }
        if (this.dataSub) {
            this.dataSub.unsubscribe();
        }
    };
    ExhibitionItemComponent.prototype.openRecommendationModal = function (evt) {
        if (evt && typeof evt.prefentDefault !== 'undefined') {
            evt.preventDefault();
        }
        this.recommendationModal.openModal();
    };
    ExhibitionItemComponent.prototype.showPreloader = function () {
        if (!this._exhibition) {
            return true;
        }
        return this._preloadingImages;
    };
    ExhibitionItemComponent.prototype._afterPreload = function () {
        var _this = this;
        this._preloadingImages = false;
        if (this.masonry) {
            setTimeout(function () { return _this.masonry.layout(); }, 100);
        }
    };
    ExhibitionItemComponent = tslib_1.__decorate([
        AutoUnsubscribe(),
        tslib_1.__metadata("design:paramtypes", [DomSanitizer,
            GlobalService,
            UrlService,
            DomSanitizer,
            ActivatedRoute,
            ComponentsService,
            UniversalPlatformService,
            SugarService,
            AppComponent,
            MetaData])
    ], ExhibitionItemComponent);
    return ExhibitionItemComponent;
}());
export { ExhibitionItemComponent };
